'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('banking-accounts-list', {
      url: '/user/banking-accounts/list',
      template: '<banking-accounts-list></banking-accounts-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/user/banking-accounts/list/banking-accounts-list.routes.js